(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["axisray-home-closer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('axisray-closer-v2')) {
    customElements.define('axisray-closer-v2', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-axr-closer-tab]')];
        this.panels = [...this.querySelectorAll('[data-axr-closer-panel]')];
        this.modal = this.querySelector('[data-axr-closer-modal]');
        this.modalMedia = this.querySelector('[data-axr-closer-modal-media]');
        this.modalDetail = this.querySelector('[data-axr-closer-modal-detail]');
        this.closeButton = this.querySelector('[data-axr-closer-close]');
        this.previousButton = this.querySelector('[data-axr-closer-previous]');
        this.nextButton = this.querySelector('[data-axr-closer-next]');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            this.select(index, false);
            if (this.mobile.matches) this.open();
          });
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
        });
        this.closeButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.close(event.detail === 0);
        });
        this.previousButton?.addEventListener('click', () => this.step(-1));
        this.nextButton?.addEventListener('click', () => this.step(1));
        this.onDocumentKeydown = (event) => {
          if (event.key === 'Escape' && this.modal?.classList.contains('is-open')) this.close(true);
        };
        document.addEventListener('keydown', this.onDocumentKeydown);
        this.select(this.index, false);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onDocumentKeydown);
        window.clearTimeout(this.switchTimer);
        this.unlockPage(false);
      }

      select(index, focus) {
        if (!this.tabs[index]) return;
        this.index = index;
        this.tabs.forEach((tab, itemIndex) => {
          const active = itemIndex === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, itemIndex) => {
          const active = itemIndex === index;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.querySelectorAll('video').forEach((video) => {
            if (active) video.play().catch(() => {});
            else video.pause();
          });
        });
        if (focus) this.tabs[index].focus({ preventScroll: true });
        if (this.modal?.classList.contains('is-open')) this.renderModal();
      }

      onTabKeydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.select(next, true);
      }

      renderModal() {
        const panel = this.panels[this.index];
        const media = panel?.querySelector('.axr-closer__media');
        const description = this.tabs[this.index]?.nextElementSibling;
        if (!media || !this.modalMedia || !this.modalDetail) return;
        this.modalMedia.replaceChildren(media.cloneNode(true));
        this.modalDetail.innerHTML = description?.innerHTML || '';
        this.modalMedia.querySelectorAll('video').forEach((video) => video.play().catch(() => {}));
      }

      open() {
        if (!this.mobile.matches || !this.modal || this.modal.classList.contains('is-open')) return;
        this.focusReturn = this.tabs[this.index];
        this.renderModal();
        this.modal.hidden = false;
        this.lockPage();
        requestAnimationFrame(() => {
          this.modal.classList.add('is-open');
          this.closeButton?.focus({ preventScroll: true });
        });
      }

      close(returnFocus = false) {
        if (!this.modal || this.modal.hidden) return;
        this.modal.classList.remove('is-open');
        const delay = this.reduced.matches ? 0 : 720;
        window.setTimeout(() => {
          this.modal.hidden = true;
          this.modalMedia?.replaceChildren();
          this.modalDetail?.replaceChildren();
          this.unlockPage(true);
          if (returnFocus) {
            requestAnimationFrame(() => this.focusReturn?.focus({ preventScroll: true }));
          }
        }, delay);
      }

      lockPage() {
        if (this.scrollLock) return;
        const pageWrapper = document.querySelector('.page-wrapper');
        const scrollingElement = document.scrollingElement || document.documentElement;
        const wrapperOverflow = pageWrapper ? getComputedStyle(pageWrapper).overflowY : '';
        const wrapperScrolls = pageWrapper
          && /^(auto|scroll|overlay)$/.test(wrapperOverflow)
          && pageWrapper.scrollHeight > pageWrapper.clientHeight;
        const scrollRoot = wrapperScrolls
          ? pageWrapper
          : scrollingElement;
        const isWindowRoot = scrollRoot === scrollingElement;
        this.scrollLock = {
          root: scrollRoot,
          isWindowRoot,
          top: isWindowRoot ? window.scrollY : scrollRoot.scrollTop,
          anchor: this,
          anchorTop: this.getBoundingClientRect().top,
          rootStyles: {
            overflow: scrollRoot.style.overflow,
            overflowY: scrollRoot.style.overflowY,
            overscrollBehavior: scrollRoot.style.overscrollBehavior,
            scrollBehavior: scrollRoot.style.scrollBehavior
          },
          bodyStyles: {
            position: document.body.style.position,
            top: document.body.style.top,
            right: document.body.style.right,
            left: document.body.style.left,
            width: document.body.style.width
          }
        };
        document.documentElement.classList.add('axr-closer-modal-open');
        if (isWindowRoot) {
          document.body.style.position = 'fixed';
          document.body.style.top = `-${this.scrollLock.top}px`;
          document.body.style.right = '0';
          document.body.style.left = '0';
          document.body.style.width = '100%';
        } else {
          scrollRoot.style.overflow = 'hidden';
          scrollRoot.style.overflowY = 'hidden';
          scrollRoot.style.overscrollBehavior = 'none';
          scrollRoot.style.scrollBehavior = 'auto';
        }
      }

      unlockPage(restoreScroll) {
        const lock = this.scrollLock;
        document.documentElement.classList.remove('axr-closer-modal-open');
        if (!lock) return;
        this.scrollLock = null;
        if (lock.isWindowRoot) {
          const htmlScrollBehavior = document.documentElement.style.scrollBehavior;
          const bodyScrollBehavior = document.body.style.scrollBehavior;
          const htmlOverflowAnchor = document.documentElement.style.overflowAnchor;
          document.documentElement.style.scrollBehavior = 'auto';
          document.body.style.scrollBehavior = 'auto';
          document.documentElement.style.overflowAnchor = 'none';
          Object.assign(document.body.style, lock.bodyStyles);
          if (restoreScroll) {
            const restorePosition = () => {
              window.scrollTo(0, lock.top);
              if (lock.anchor?.isConnected) {
                const anchorDelta = lock.anchor.getBoundingClientRect().top - lock.anchorTop;
                if (Math.abs(anchorDelta) > 0.5) window.scrollBy(0, anchorDelta);
              }
            };
            restorePosition();
            requestAnimationFrame(() => {
              restorePosition();
              requestAnimationFrame(() => {
                document.documentElement.style.scrollBehavior = htmlScrollBehavior;
                document.body.style.scrollBehavior = bodyScrollBehavior;
                document.documentElement.style.overflowAnchor = htmlOverflowAnchor;
              });
            });
          } else {
            document.documentElement.style.scrollBehavior = htmlScrollBehavior;
            document.body.style.scrollBehavior = bodyScrollBehavior;
            document.documentElement.style.overflowAnchor = htmlOverflowAnchor;
          }
        } else {
          Object.assign(lock.root.style, lock.rootStyles);
          if (restoreScroll) {
            lock.root.scrollTop = lock.top;
            requestAnimationFrame(() => {
              lock.root.scrollTop = lock.top;
            });
          }
        }
      }

      step(direction) {
        const next = (this.index + direction + this.tabs.length) % this.tabs.length;
        if (!this.modal?.classList.contains('is-open') || this.reduced.matches) {
          this.select(next, false);
          return;
        }
        window.clearTimeout(this.switchTimer);
        this.modal.classList.add('is-switching');
        this.switchTimer = window.setTimeout(() => {
          this.select(next, false);
          requestAnimationFrame(() => requestAnimationFrame(() => this.modal?.classList.remove('is-switching')));
        }, 360);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axisray-home-header"] && !Shopify.designMode) return;
  try {
    
  const axhInitReveal = (root = document) => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const titleSelector = '.axh:not(.axh-hero) .axh-title';
    const copySelector = [
      '.axr-concept__text',
      '.axh-concept__text',
      '.axh-optical__copy',
      '.axr-system__subheading',
      '.axh-system__subheading',
      '.axh-software__subheading',
      '.axr-hotspots__subheading',
      '.axh-hotspots__subheading',
      '.axh-box__subheading'
    ].join(',');
    const titles = [...root.querySelectorAll(titleSelector)];
    const copies = [...root.querySelectorAll(copySelector)];
    const items = [...new Set([...titles, ...copies])].filter((item) => !item.classList.contains('axh-reveal'));
    if (!items.length) return;
    items.forEach((item) => {
      item.classList.add('axh-reveal');
      if (copies.includes(item)) item.classList.add('axh-reveal--copy');
    });
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.16 });
    items.forEach((item) => observer.observe(item));
  };

  const axhStartReveal = () => axhInitReveal(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', axhStartReveal, { once: true });
  else axhStartReveal();
  document.addEventListener('shopify:section:load', (event) => axhInitReveal(event.target));

  const axhPlayMedia = (root) => {
    const scope = root || document;
    document.querySelectorAll('[data-axh-switcher] video, axisray-carousel video, axisray-system video').forEach((video) => {
      if (video.closest('axisray-responsive-media')) return;
      const panel = video.closest('.axh-switch-panel');
      const slide = video.closest('.axh-carousel__slide');
      const systemPanel = video.closest('[data-axh-system-media]');
      const shouldPlay = panel
        ? panel.classList.contains('is-active')
        : slide
          ? slide.classList.contains('is-active')
          : systemPanel
            ? systemPanel.classList.contains('is-active')
            : scope.contains(video);
      if (shouldPlay) video.play().catch(() => {});
      else video.pause();
    });
    document.querySelectorAll('axisray-responsive-media').forEach((media) => media.sync?.());
  };

  if (!customElements.get('axisray-responsive-media')) {
    customElements.define('axisray-responsive-media', class extends HTMLElement {
      connectedCallback() {
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.inView = true;
        this.changeBound = () => this.sync();
        this.visibilityBound = () => this.sync();
        this.mobile.addEventListener?.('change', this.changeBound);
        document.addEventListener('visibilitychange', this.visibilityBound);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inView = Boolean(entries[0]?.isIntersecting);
            this.sync();
          }, { rootMargin: '18% 0px', threshold: 0.01 });
          this.observer.observe(this);
        }
        this.sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.mobile?.removeEventListener?.('change', this.changeBound);
        document.removeEventListener('visibilitychange', this.visibilityBound);
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      contextIsActive() {
        const panel = this.closest('.axh-switch-panel');
        if (panel && !panel.classList.contains('is-active')) return false;
        const slide = this.closest('.axh-carousel__slide');
        if (slide && !slide.classList.contains('is-active')) return false;
        const systemPanel = this.closest('[data-axh-system-media]');
        if (systemPanel && !systemPanel.classList.contains('is-active')) return false;
        return true;
      }

      activeVariant() {
        const mobileVariant = this.querySelector('[data-axh-media-variant="mobile"]');
        if (this.mobile?.matches && mobileVariant) return mobileVariant;
        return this.querySelector('[data-axh-media-variant="desktop"]');
      }

      sync() {
        const activeVariant = this.activeVariant();
        const shouldPlay = this.dataset.autoplay === 'true' && this.inView && this.contextIsActive() && !document.hidden;
        this.querySelectorAll('video').forEach((video) => {
          const active = activeVariant?.contains(video) && shouldPlay;
          if (active) {
            if (video.preload === 'none') {
              video.preload = 'metadata';
              video.load();
            }
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }
    });
  }

  if (!customElements.get('axisray-header')) {
    customElements.define('axisray-header', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.axh-header__toggle');
        this.menu = this.querySelector('.axh-header__mobile');
        if (!this.button || !this.menu) return;
        this.button.addEventListener('click', () => this.toggle());
        this.menu.addEventListener('click', (event) => {
          if (event.target.closest('a')) this.close();
        });
      }

      toggle() {
        const open = this.button.getAttribute('aria-expanded') !== 'true';
        this.button.setAttribute('aria-expanded', String(open));
        this.menu.hidden = !open;
        this.menu.classList.toggle('is-open', open);
      }

      close() {
        this.button.setAttribute('aria-expanded', 'false');
        this.menu.hidden = true;
        this.menu.classList.remove('is-open');
      }
    });
  }

  if (!customElements.get('axisray-carousel')) {
    customElements.define('axisray-carousel', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.axh-carousel__viewport');
        this.slides = [...this.querySelectorAll('.axh-carousel__slide')];
        this.dots = [...this.querySelectorAll('.axh-carousel__dot')];
        this.pauseButton = this.querySelector('.axh-carousel__pause');
        this.delay = Number(this.dataset.autoplayDelay || 6000);
        this.index = 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reducedMotion.matches;
        this.inView = false;
        this.remaining = this.delay;
        this.startedAt = 0;
        this.dragging = false;
        this.targetIndex = null;
        if (!this.viewport || this.slides.length === 0) return;
        this.style.setProperty('--axh-carousel-delay', `${this.delay}ms`);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index)));
        this.pauseButton?.addEventListener('click', () => this.togglePause());
        this.viewport.addEventListener('scroll', () => this.onScroll(), { passive: true });
        this.viewport.addEventListener('pointerdown', (event) => this.pointerDown(event));
        this.viewport.addEventListener('pointermove', (event) => this.pointerMove(event));
        this.viewport.addEventListener('pointerup', () => this.pointerUp());
        this.viewport.addEventListener('pointercancel', () => this.pointerUp());
        this.visibilityHandler = () => this.visibilityChanged();
        document.addEventListener('visibilitychange', this.visibilityHandler);
        this.intersectionObserver = new IntersectionObserver((entries) => this.viewportVisibilityChanged(entries), {
          threshold: [0, 0.35]
        });
        this.intersectionObserver.observe(this);
        this.activate(0);
        this.updatePauseButton();
        if (this.reducedMotion.matches && this.pauseButton) {
          this.pauseButton.disabled = true;
          this.pauseButton.setAttribute('aria-label', 'Carousel autoplay disabled');
        }
      }

      disconnectedCallback() {
        this.stop(true);
        window.clearTimeout(this.scrollSettleTimer);
        cancelAnimationFrame(this.scrollAnimationFrame);
        this.intersectionObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.visibilityHandler);
      }

      go(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.targetIndex = this.index;
        const slide = this.slides[this.index];
        const left = slide.offsetLeft - (this.viewport.clientWidth - slide.clientWidth) / 2;
        this.animateViewportTo(left);
        this.activate(this.index);
        this.restart();
      }

      animateViewportTo(left, duration = 940) {
        cancelAnimationFrame(this.scrollAnimationFrame);
        window.clearTimeout(this.scrollSettleTimer);
        this.viewport.classList.add('is-animating');
        const start = this.viewport.scrollLeft;
        const distance = left - start;
        if (this.reducedMotion.matches || Math.abs(distance) < 1) {
          this.viewport.scrollLeft = left;
          this.viewport.classList.remove('is-animating');
          this.targetIndex = null;
          return;
        }
        const startedAt = performance.now();
        const tick = (now) => {
          const progress = Math.min(1, (now - startedAt) / duration);
          const eased = 1 - Math.pow(1 - progress, 4);
          this.viewport.scrollLeft = start + distance * eased;
          if (progress < 1) {
            this.scrollAnimationFrame = requestAnimationFrame(tick);
            return;
          }
          this.viewport.scrollLeft = left;
          this.viewport.classList.remove('is-animating');
          this.targetIndex = null;
        };
        this.scrollAnimationFrame = requestAnimationFrame(tick);
      }

      activate(index) {
        this.index = index;
        this.slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
        this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
        axhPlayMedia(this);
      }

      onScroll() {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          if (this.targetIndex !== null) return;
          const center = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
          let closest = 0;
          let distance = Infinity;
          this.slides.forEach((slide, index) => {
            const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
            const nextDistance = Math.abs(center - slideCenter);
            if (nextDistance < distance) {
              closest = index;
              distance = nextDistance;
            }
          });
          if (closest !== this.index) {
            this.activate(closest);
            this.restart();
          }
        });
      }

      pointerDown(event) {
        if (event.pointerType === 'touch') return;
        cancelAnimationFrame(this.scrollAnimationFrame);
        this.viewport.classList.remove('is-animating');
        this.targetIndex = null;
        this.dragging = true;
        this.dragStart = event.clientX;
        this.scrollStart = this.viewport.scrollLeft;
        this.viewport.classList.add('is-dragging');
        this.viewport.setPointerCapture(event.pointerId);
      }

      pointerMove(event) {
        if (!this.dragging) return;
        this.viewport.scrollLeft = this.scrollStart - (event.clientX - this.dragStart);
      }

      pointerUp() {
        if (!this.dragging) return;
        this.dragging = false;
        this.viewport.classList.remove('is-dragging');
        this.go(this.index);
      }

      togglePause() {
        if (this.reducedMotion.matches) return;
        this.paused = !this.paused;
        this.updatePauseButton();
        if (this.paused) this.stop(true);
        else this.start();
      }

      updatePauseButton() {
        if (!this.pauseButton) return;
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.setAttribute('aria-label', this.paused ? 'Play carousel' : 'Pause carousel');
      }

      start() {
        if (this.paused || !this.inView || this.reducedMotion.matches || this.slides.length < 2 || document.hidden) return;
        if (this.classList.contains('is-playing')) return;
        window.clearTimeout(this.timer);
        if (!this.classList.contains('has-started')) {
          this.classList.add('has-started');
          void this.offsetWidth;
        }
        this.classList.add('is-playing');
        this.startedAt = performance.now();
        this.timer = window.setTimeout(() => {
          this.remaining = this.delay;
          this.go(this.index + 1);
        }, Math.max(0, this.remaining));
      }

      stop(preserveProgress = true) {
        if (preserveProgress && this.classList.contains('is-playing') && this.startedAt) {
          this.remaining = Math.max(0, this.remaining - (performance.now() - this.startedAt));
        }
        window.clearTimeout(this.timer);
        this.classList.remove('is-playing');
        this.startedAt = 0;
        if (!preserveProgress) {
          this.classList.remove('has-started');
          this.remaining = this.delay;
        }
      }

      restart() {
        this.stop(false);
        if (!this.paused) this.start();
      }

      viewportVisibilityChanged(entries) {
        const entry = entries[0];
        const inView = Boolean(entry?.isIntersecting && entry.intersectionRatio >= 0.35);
        if (inView === this.inView) return;
        this.inView = inView;
        if (this.inView) this.start();
        else this.stop(true);
      }

      visibilityChanged() {
        if (document.hidden) this.stop(true);
        else this.start();
      }
    });
  }

  if (!customElements.get('axisray-switcher')) {
    customElements.define('axisray-switcher', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-axh-tab]')];
        this.panels = [...this.querySelectorAll('[data-axh-panel]')];
        this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.select(index, false, true)));
        this.tabs.forEach((tab, index) => tab.addEventListener('keydown', (event) => this.keydown(event, index)));
        this.select(Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')));
      }

      select(index, focus = false, alignTab = false) {
        if (!this.tabs[index]) return;
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });
        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
        });
        if (focus) this.tabs[index].focus();
        if (alignTab) this.alignSelectedTab(index);
        axhPlayMedia(this);
        this.dispatchEvent(new CustomEvent('axisray:change', { bubbles: true, detail: { index } }));
      }

      alignSelectedTab(index) {
        const tablist = this.querySelector('.axh-software__tabs, .axh-closer__tabs');
        const tab = this.tabs[index];
        if (!tablist || !tab || tablist.scrollWidth <= tablist.clientWidth) return;
        const left = tab.offsetLeft - ((tablist.clientWidth - tab.offsetWidth) / 2);
        tablist.scrollTo({
          left: Math.max(0, left),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      keydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.select(next, true, true);
      }
    });
  }

  const axhLockModalPage = (owner) => {
    if (owner.pageLockStyles) return;
    const root = document.documentElement;
    const body = document.body;
    const scrollbarGap = Math.max(0, window.innerWidth - root.clientWidth);
    owner.scrollY = window.scrollY;
    owner.pageLockStyles = {
      rootOverflow: root.style.overflow,
      rootScrollBehavior: root.style.scrollBehavior,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyRight: body.style.right,
      bodyLeft: body.style.left,
      bodyWidth: body.style.width,
      bodyOverflow: body.style.overflow,
      bodyPaddingRight: body.style.paddingRight
    };
    root.style.scrollBehavior = 'auto';
    root.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = `-${owner.scrollY}px`;
    body.style.right = '0';
    body.style.left = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    if (scrollbarGap) body.style.paddingRight = `${scrollbarGap}px`;
  };

  const axhUnlockModalPage = (owner) => {
    if (!owner.pageLockStyles) return;
    const root = document.documentElement;
    const body = document.body;
    const styles = owner.pageLockStyles;
    const scrollY = owner.scrollY;
    root.style.scrollBehavior = 'auto';
    body.style.position = styles.bodyPosition;
    body.style.top = styles.bodyTop;
    body.style.right = styles.bodyRight;
    body.style.left = styles.bodyLeft;
    body.style.width = styles.bodyWidth;
    body.style.overflow = styles.bodyOverflow;
    body.style.paddingRight = styles.bodyPaddingRight;
    window.scrollTo(0, scrollY);
    root.style.overflow = styles.rootOverflow;
    owner.pageLockStyles = null;
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollY);
      root.style.scrollBehavior = styles.rootScrollBehavior;
    });
  };

  if (!customElements.get('axisray-closer')) {
    customElements.define('axisray-closer', class extends HTMLElement {
      connectedCallback() {
        this.switcher = this.querySelector('axisray-switcher');
        this.tabs = [...this.querySelectorAll('.axh-closer__tab')];
        this.panels = [...this.querySelectorAll('.axh-closer__panels > .axh-switch-panel')];
        this.modal = this.querySelector('[data-axh-closer-modal]');
        this.modalMedia = this.querySelector('[data-axh-closer-modal-media]');
        this.modalDetail = this.querySelector('[data-axh-closer-modal-detail]');
        this.modalHome = this.modal?.parentNode || null;
        this.modalNext = this.modal?.nextSibling || null;
        this.closeButton = this.querySelector('[data-axh-closer-close]');
        this.previousButton = this.querySelector('[data-axh-closer-previous]');
        this.nextButton = this.querySelector('[data-axh-closer-next]');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.closing = false;
        this.activeIndex = Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
        this.clickBound = (event) => this.clicked(event);
        this.keydownBound = (event) => this.keydown(event);
        this.closeBound = () => this.closeDetail();
        this.previousBound = () => this.step(-1);
        this.nextBound = () => this.step(1);
        this.changeBound = (event) => {
          this.activeIndex = event.detail?.index ?? this.activeIndex;
          if (this.classList.contains('is-detail-open')) this.renderModal();
        };
        this.addEventListener('click', this.clickBound);
        this.addEventListener('axisray:change', this.changeBound);
        this.closeButton?.addEventListener('click', this.closeBound);
        this.previousButton?.addEventListener('click', this.previousBound);
        this.nextButton?.addEventListener('click', this.nextBound);
        document.addEventListener('keydown', this.keydownBound);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.clickBound);
        this.removeEventListener('axisray:change', this.changeBound);
        this.closeButton?.removeEventListener('click', this.closeBound);
        this.previousButton?.removeEventListener('click', this.previousBound);
        this.nextButton?.removeEventListener('click', this.nextBound);
        document.removeEventListener('keydown', this.keydownBound);
        this.finishClose(false);
      }

      clicked(event) {
        const tab = event.target.closest('.axh-closer__tab');
        if (!tab || !this.mobile.matches) return;
        const index = this.tabs.indexOf(tab);
        if (index < 0) return;
        this.activeIndex = index;
        window.requestAnimationFrame(() => this.openDetail());
      }

      openDetail() {
        if (!this.mobile.matches || !this.modal || this.classList.contains('is-detail-open')) return;
        this.focusReturn = this.tabs[this.activeIndex];
        this.closing = false;
        this.renderModal();
        if (this.modal.parentNode !== document.body) document.body.append(this.modal);
        this.modal.hidden = false;
        this.classList.add('is-detail-open');
        document.documentElement.classList.add('axh-modal-open');
        requestAnimationFrame(() => {
          this.modal.classList.add('is-open');
          this.closeButton?.focus({ preventScroll: true });
          axhPlayMedia(this.modal);
        });
      }

      closeDetail() {
        if (!this.classList.contains('is-detail-open') || this.closing) return;
        this.closing = true;
        this.modal?.classList.remove('is-open');
        const delay = this.reduced.matches ? 0 : 440;
        window.setTimeout(() => this.finishClose(true), delay);
      }

      finishClose(restoreFocus = true) {
        if (!this.classList.contains('is-detail-open') && !this.closing) return;
        this.classList.remove('is-detail-open');
        this.modal?.classList.remove('is-open');
        if (this.modal) this.modal.hidden = true;
        if (this.modalMedia) this.modalMedia.replaceChildren();
        if (this.modalDetail) this.modalDetail.replaceChildren();
        if (this.modal && this.modalHome) {
          if (this.modalNext?.parentNode === this.modalHome) this.modalHome.insertBefore(this.modal, this.modalNext);
          else this.modalHome.append(this.modal);
        }
        document.documentElement.classList.remove('axh-modal-open');
        this.closing = false;
        axhPlayMedia(this);
        if (restoreFocus) this.focusReturn?.focus({ preventScroll: true });
      }

      renderModal() {
        const panel = this.panels[this.activeIndex];
        const media = panel?.querySelector('.axh-closer__media');
        const detail = panel?.querySelector('.axh-closer__mobile-detail');
        if (!media || !this.modalMedia || !this.modalDetail) return;
        const mediaClone = media.cloneNode(true);
        mediaClone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        this.modalMedia.replaceChildren(mediaClone);
        this.modalDetail.innerHTML = detail?.innerHTML || '';
        axhPlayMedia(this.modal);
      }

      step(direction) {
        if (!this.tabs.length) return;
        const next = (this.activeIndex + direction + this.tabs.length) % this.tabs.length;
        this.activeIndex = next;
        this.switcher?.select(next, false, false);
      }

      keydown(event) {
        if (!this.classList.contains('is-detail-open')) return;
        if (event.key === 'Escape') this.closeDetail();
        if (event.key !== 'Tab' || !this.modal) return;
        const focusable = [...this.modal.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  if (!customElements.get('axisray-hotspot-explorer')) {
    customElements.define('axisray-hotspot-explorer', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-axh-hotspot-viewport]');
        this.canvas = this.querySelector('[data-axh-hotspot-canvas]');
        this.expandButton = this.querySelector('[data-axh-hotspot-expand]');
        this.closeButton = this.querySelector('[data-axh-hotspot-close]');
        this.sheetCloseButton = this.querySelector('[data-axh-hotspot-sheet-close]');
        this.tabs = [...this.querySelectorAll('.axh-hotspots__point')];
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.pointers = new Map();
        this.panX = 0;
        this.panY = 0;
        this.zoom = 1;
        this.scrollY = 0;
        this.expandBound = () => this.openExplorer();
        this.closeBound = () => this.closeExplorer();
        this.sheetCloseBound = () => this.closeSheet();
        this.clickBound = (event) => this.clicked(event);
        this.keydownBound = (event) => this.keydown(event);
        this.pointerDownBound = (event) => this.pointerDown(event);
        this.pointerMoveBound = (event) => this.pointerMove(event);
        this.pointerUpBound = (event) => this.pointerUp(event);
        this.resizeBound = () => this.clampTransform();
        this.expandButton?.addEventListener('click', this.expandBound);
        this.closeButton?.addEventListener('click', this.closeBound);
        this.sheetCloseButton?.addEventListener('click', this.sheetCloseBound);
        this.addEventListener('click', this.clickBound);
        this.viewport?.addEventListener('pointerdown', this.pointerDownBound);
        this.viewport?.addEventListener('pointermove', this.pointerMoveBound);
        this.viewport?.addEventListener('pointerup', this.pointerUpBound);
        this.viewport?.addEventListener('pointercancel', this.pointerUpBound);
        window.addEventListener('resize', this.resizeBound, { passive: true });
        document.addEventListener('keydown', this.keydownBound);
      }

      disconnectedCallback() {
        this.expandButton?.removeEventListener('click', this.expandBound);
        this.closeButton?.removeEventListener('click', this.closeBound);
        this.sheetCloseButton?.removeEventListener('click', this.sheetCloseBound);
        this.removeEventListener('click', this.clickBound);
        this.viewport?.removeEventListener('pointerdown', this.pointerDownBound);
        this.viewport?.removeEventListener('pointermove', this.pointerMoveBound);
        this.viewport?.removeEventListener('pointerup', this.pointerUpBound);
        this.viewport?.removeEventListener('pointercancel', this.pointerUpBound);
        window.removeEventListener('resize', this.resizeBound);
        document.removeEventListener('keydown', this.keydownBound);
        if (this.classList.contains('is-explorer-open')) this.unlockPage();
      }

      clicked(event) {
        const tab = event.target.closest('.axh-hotspots__point');
        if (!tab || !this.mobile.matches || !this.classList.contains('is-explorer-open')) return;
        this.classList.add('is-sheet-open');
        this.sheetCloseButton?.focus({ preventScroll: true });
        axhPlayMedia(this);
      }

      openExplorer() {
        if (!this.mobile.matches || this.classList.contains('is-explorer-open')) return;
        this.focusReturn = this.expandButton;
        this.panX = 0;
        this.panY = 0;
        this.zoom = 1;
        this.updateTransform();
        this.lockPage();
        this.classList.add('is-explorer-open');
        this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', 'true');
        window.requestAnimationFrame(() => {
          this.clampTransform();
          this.closeButton?.focus({ preventScroll: true });
        });
      }

      closeExplorer() {
        if (!this.classList.contains('is-explorer-open')) return;
        this.classList.remove('is-sheet-open', 'is-explorer-open');
        this.removeAttribute('role');
        this.removeAttribute('aria-modal');
        this.pointers.clear();
        this.unlockPage();
        this.focusReturn?.focus({ preventScroll: true });
      }

      closeSheet() {
        if (!this.classList.contains('is-sheet-open')) return;
        this.classList.remove('is-sheet-open');
        const selected = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
        selected?.focus({ preventScroll: true });
      }

      keydown(event) {
        if (event.key !== 'Escape' || !this.classList.contains('is-explorer-open')) return;
        if (this.classList.contains('is-sheet-open')) this.closeSheet();
        else this.closeExplorer();
      }

      pointerDown(event) {
        if (!this.classList.contains('is-explorer-open') || event.target.closest('button')) return;
        this.viewport?.setPointerCapture?.(event.pointerId);
        this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (this.pointers.size === 1) {
          this.dragStart = { x: event.clientX, y: event.clientY, panX: this.panX, panY: this.panY };
        } else if (this.pointers.size === 2) {
          const points = [...this.pointers.values()];
          this.pinchStartDistance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
          this.pinchStartZoom = this.zoom;
        }
      }

      pointerMove(event) {
        if (!this.pointers.has(event.pointerId) || !this.classList.contains('is-explorer-open')) return;
        this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (this.pointers.size === 1 && this.dragStart) {
          this.panX = this.dragStart.panX + event.clientX - this.dragStart.x;
          this.panY = this.dragStart.panY + event.clientY - this.dragStart.y;
        } else if (this.pointers.size === 2 && this.pinchStartDistance) {
          const points = [...this.pointers.values()];
          const distance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
          this.zoom = Math.max(1, Math.min(2.5, this.pinchStartZoom * distance / this.pinchStartDistance));
        }
        this.clampTransform();
      }

      pointerUp(event) {
        if (!this.pointers.has(event.pointerId)) return;
        this.pointers.delete(event.pointerId);
        if (this.pointers.size === 1) {
          const point = [...this.pointers.values()][0];
          this.dragStart = { x: point.x, y: point.y, panX: this.panX, panY: this.panY };
        } else {
          this.dragStart = null;
          this.pinchStartDistance = 0;
        }
      }

      clampTransform() {
        if (!this.canvas || !this.viewport || !this.classList.contains('is-explorer-open')) return;
        const maxX = Math.max(0, (this.canvas.offsetWidth * this.zoom - this.viewport.clientWidth) / 2);
        const maxY = Math.max(0, (this.canvas.offsetHeight * this.zoom - this.viewport.clientHeight) / 2);
        this.panX = Math.max(-maxX, Math.min(maxX, this.panX));
        this.panY = Math.max(-maxY, Math.min(maxY, this.panY));
        this.updateTransform();
      }

      updateTransform() {
        this.style.setProperty('--axh-hotspot-pan-x', `${this.panX}px`);
        this.style.setProperty('--axh-hotspot-pan-y', `${this.panY}px`);
        this.style.setProperty('--axh-hotspot-zoom', String(this.zoom));
      }

      lockPage() {
        axhLockModalPage(this);
      }

      unlockPage() {
        axhUnlockModalPage(this);
      }
    });
  }

  if (!customElements.get('axisray-system')) {
    customElements.define('axisray-system', class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.axh-system__stage');
        this.viewport = this.querySelector('.axh-system__viewport');
        this.track = this.querySelector('.axh-system__track');
        this.cards = [...this.querySelectorAll('[data-axh-system-card]')];
        this.mediaPanels = [...this.querySelectorAll('[data-axh-system-media]')];
        this.previousButton = this.querySelector('[data-axh-system-previous]');
        this.nextButton = this.querySelector('[data-axh-system-next]');
        this.currentOutput = this.querySelector('[data-axh-system-current]');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.completed = false;
        this.nearby = false;
        this.frame = 0;
        this.mediaToken = 0;
        this.lastScrollY = window.scrollY;
        this.pointerStart = null;
        this.scrollBound = () => this.requestUpdate();
        this.resizeBound = () => {
          this.positionTrack(this.index);
          this.requestUpdate();
        };
        this.previousBound = () => this.select(this.index - 1, true);
        this.nextBound = () => this.select(this.index + 1, true);
        this.pointerDownBound = (event) => this.pointerDown(event);
        this.pointerUpBound = (event) => this.pointerUp(event);
        this.cardHandlers = this.cards.map((card, index) => {
          const click = () => this.select(index, true);
          const keydown = (event) => this.keydown(event, index);
          card.addEventListener('click', click);
          card.addEventListener('keydown', keydown);
          return { card, click, keydown };
        });
        this.previousButton?.addEventListener('click', this.previousBound);
        this.nextButton?.addEventListener('click', this.nextBound);
        this.viewport?.addEventListener('pointerdown', this.pointerDownBound, { passive: true });
        this.viewport?.addEventListener('pointerup', this.pointerUpBound, { passive: true });
        window.addEventListener('scroll', this.scrollBound, { passive: true });
        window.addEventListener('resize', this.resizeBound, { passive: true });
        this.observer = new IntersectionObserver((entries) => {
          this.nearby = entries.some((entry) => entry.isIntersecting);
          if (this.nearby) this.requestUpdate();
        }, { rootMargin: '35% 0px', threshold: 0.01 });
        this.observer.observe(this);
        this.commit(0, false);
        this.preloadPanel(1);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        window.removeEventListener('scroll', this.scrollBound);
        window.removeEventListener('resize', this.resizeBound);
        this.previousButton?.removeEventListener('click', this.previousBound);
        this.nextButton?.removeEventListener('click', this.nextBound);
        this.viewport?.removeEventListener('pointerdown', this.pointerDownBound);
        this.viewport?.removeEventListener('pointerup', this.pointerUpBound);
        this.cardHandlers?.forEach(({ card, click, keydown }) => {
          card.removeEventListener('click', click);
          card.removeEventListener('keydown', keydown);
        });
      }

      requestUpdate() {
        if (this.frame || !this.nearby) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateFromScroll();
        });
      }

      updateFromScroll() {
        if (!this.stage || this.cards.length < 2 || this.reduced.matches || this.completed) return;
        const rect = this.getBoundingClientRect();
        const stickyTop = Number.parseFloat(getComputedStyle(this.stage).top) || 0;
        const travel = Math.max(1, this.offsetHeight - this.stage.offsetHeight);
        const progress = Math.max(0, Math.min(1, (stickyTop - rect.top) / travel));
        const movingForward = window.scrollY >= this.lastScrollY;
        this.lastScrollY = window.scrollY;
        const next = Math.min(this.cards.length - 1, Math.max(0, Math.round(progress * (this.cards.length - 1))));
        if (next !== this.index) this.select(next, false);
        if (movingForward && progress >= 0.985) {
          this.completed = true;
          this.classList.add('is-interaction-complete');
          this.select(this.cards.length - 1, false);
        }
      }

      preloadPanel(index) {
        const panel = this.mediaPanels[index];
        if (!panel) return Promise.resolve();
        const images = [...panel.querySelectorAll('img')];
        const imageReady = images.map((image) => {
          if (image.complete) return image.decode?.().catch(() => {}) || Promise.resolve();
          return new Promise((resolve) => {
            image.addEventListener('load', resolve, { once: true });
            image.addEventListener('error', resolve, { once: true });
          });
        });
        const responsive = panel.querySelector('axisray-responsive-media');
        const variant = responsive?.activeVariant?.();
        const video = variant?.querySelector('video') || panel.querySelector('video');
        let videoReady = Promise.resolve();
        if (video && video.readyState < 2) {
          video.preload = 'metadata';
          video.load();
          videoReady = Promise.race([
            new Promise((resolve) => video.addEventListener('loadeddata', resolve, { once: true })),
            new Promise((resolve) => window.setTimeout(resolve, 600))
          ]);
        }
        return Promise.all([...imageReady, videoReady]);
      }

      select(index, focus = false) {
        if (!this.cards.length) return;
        const next = Math.min(this.cards.length - 1, Math.max(0, index));
        const token = ++this.mediaToken;
        this.preloadPanel(next).then(() => {
          if (token !== this.mediaToken) return;
          this.commit(next, focus);
          this.preloadPanel(Math.min(this.cards.length - 1, next + 1));
        });
      }

      commit(index, focus = false) {
        this.index = index;
        this.cards.forEach((card, cardIndex) => {
          const active = cardIndex === index;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-current', String(active));
          card.setAttribute('tabindex', active ? '0' : '-1');
        });
        this.mediaPanels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
        });
        this.positionTrack(index);
        if (this.currentOutput) this.currentOutput.textContent = String(index + 1).padStart(2, '0');
        if (this.previousButton) this.previousButton.disabled = index === 0;
        if (this.nextButton) this.nextButton.disabled = index === this.cards.length - 1;
        if (focus) this.cards[index]?.focus({ preventScroll: true });
        axhPlayMedia(this);
      }

      positionTrack(index) {
        if (!this.track || !this.cards[index]) return;
        const firstOffset = this.cards[0].offsetLeft;
        const offset = this.cards[index].offsetLeft - firstOffset;
        this.track.style.transform = `translate3d(${-offset}px, 0, 0)`;
      }

      keydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = Math.min(this.cards.length - 1, index + 1);
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = Math.max(0, index - 1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.cards.length - 1;
        this.select(next, true);
      }

      pointerDown(event) {
        if (!event.isPrimary || event.pointerType === 'mouse') return;
        this.pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
        this.viewport?.setPointerCapture?.(event.pointerId);
      }

      pointerUp(event) {
        if (!this.pointerStart || event.pointerId !== this.pointerStart.id) return;
        const deltaX = event.clientX - this.pointerStart.x;
        const deltaY = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        if (Math.abs(deltaX) < 42 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
        this.completed = true;
        this.classList.add('is-interaction-complete');
        this.select(this.index + (deltaX < 0 ? 1 : -1), false);
      }
    });
  }

  if (!customElements.get('axisray-system-legacy')) {
    customElements.define('axisray-system-legacy', class extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.axh-system__stage');
        this.viewport = this.querySelector('.axh-system__viewport');
        this.track = this.querySelector('.axh-system__track');
        this.cards = [...this.querySelectorAll('[data-axh-system-card]')];
        this.mediaPanels = [...this.querySelectorAll('[data-axh-system-media]')];
        this.previousButton = this.querySelector('[data-axh-system-previous]');
        this.nextButton = this.querySelector('[data-axh-system-next]');
        this.currentOutput = this.querySelector('[data-axh-system-current]');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = -1;
        this.active = false;
        this.completed = false;
        this.releasing = false;
        this.nearby = false;
        this.inputListening = false;
        this.guardListening = false;
        this.gestureLocked = false;
        this.wheelTotal = 0;
        this.wheelDirection = 0;
        this.exitReady = false;
        this.exitTimer = 0;
        this.touchPoint = null;
        this.touchTotal = 0;
        this.touchActivated = false;
        this.pointerStart = null;
        this.ignoreClickUntil = 0;
        this.pageLock = null;
        this.wheelBound = (event) => this.wheel(event);
        this.touchStartBound = (event) => this.touchStart(event);
        this.touchMoveBound = (event) => this.touchMove(event);
        this.touchEndBound = (event) => this.touchEnd(event);
        this.touchCancelBound = () => this.resetTouch();
        this.pageKeydownBound = (event) => this.pageKeydown(event);
        this.guardBound = () => this.guardActivePosition();
        this.resizeBound = () => this.positionTrack(this.index);
        this.reducedChangeBound = () => this.reducedChange();
        this.cardHandlers = this.cards.map((card, index) => {
          const click = () => {
            if (Date.now() < this.ignoreClickUntil) return;
            this.activate(index);
          };
          const keydown = (event) => this.keydown(event, index);
          card.addEventListener('click', click);
          card.addEventListener('keydown', keydown);
          return { card, click, keydown };
        });
        this.previousBound = () => this.step(-1);
        this.nextBound = () => this.step(1);
        this.pointerDownBound = (event) => this.pointerDown(event);
        this.pointerUpBound = (event) => this.pointerUp(event);
        this.pointerCancelBound = () => {
          this.pointerStart = null;
        };
        this.previousButton?.addEventListener('click', this.previousBound);
        this.nextButton?.addEventListener('click', this.nextBound);
        this.viewport?.addEventListener('pointerdown', this.pointerDownBound, { passive: true });
        this.viewport?.addEventListener('pointerup', this.pointerUpBound, { passive: true });
        this.viewport?.addEventListener('pointercancel', this.pointerCancelBound, { passive: true });
        window.addEventListener('resize', this.resizeBound, { passive: true });
        this.reduced.addEventListener?.('change', this.reducedChangeBound);
        this.observer = new IntersectionObserver((entries) => {
          this.nearby = entries.some((entry) => entry.isIntersecting);
          this.syncInputListeners();
        }, { rootMargin: '18% 0px', threshold: 0.01 });
        if (this.stage) this.observer.observe(this.stage);
        this.select(0);
        this.syncInputListeners();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.guardFrame);
        clearTimeout(this.wheelQuietTimer);
        clearTimeout(this.exitTimer);
        this.observer?.disconnect();
        this.unlockPage();
        this.removeInputListeners();
        this.removeGuardListener();
        window.removeEventListener('resize', this.resizeBound);
        this.reduced.removeEventListener?.('change', this.reducedChangeBound);
        this.previousButton?.removeEventListener('click', this.previousBound);
        this.nextButton?.removeEventListener('click', this.nextBound);
        this.viewport?.removeEventListener('pointerdown', this.pointerDownBound);
        this.viewport?.removeEventListener('pointerup', this.pointerUpBound);
        this.viewport?.removeEventListener('pointercancel', this.pointerCancelBound);
        this.cardHandlers?.forEach(({ card, click, keydown }) => {
          card.removeEventListener('click', click);
          card.removeEventListener('keydown', keydown);
        });
      }

      syncInputListeners() {
        const shouldListen = (this.nearby || this.active) && !this.completed && !this.reduced.matches && this.cards.length > 1;
        if (shouldListen && !this.inputListening) {
          this.inputListening = true;
          window.addEventListener('wheel', this.wheelBound, { passive: false });
          window.addEventListener('touchstart', this.touchStartBound, { passive: true });
          window.addEventListener('touchmove', this.touchMoveBound, { passive: false });
          window.addEventListener('touchend', this.touchEndBound, { passive: true });
          window.addEventListener('touchcancel', this.touchCancelBound, { passive: true });
          window.addEventListener('keydown', this.pageKeydownBound);
        } else if (!shouldListen) {
          this.removeInputListeners();
        }
        if (this.active && !this.guardListening) {
          this.guardListening = true;
          window.addEventListener('scroll', this.guardBound, { passive: true });
        } else if (!this.active) {
          this.removeGuardListener();
        }
      }

      removeInputListeners() {
        if (!this.inputListening) return;
        this.inputListening = false;
        window.removeEventListener('wheel', this.wheelBound);
        window.removeEventListener('touchstart', this.touchStartBound);
        window.removeEventListener('touchmove', this.touchMoveBound);
        window.removeEventListener('touchend', this.touchEndBound);
        window.removeEventListener('touchcancel', this.touchCancelBound);
        window.removeEventListener('keydown', this.pageKeydownBound);
      }

      removeGuardListener() {
        if (!this.guardListening) return;
        this.guardListening = false;
        window.removeEventListener('scroll', this.guardBound);
      }

      stickyTop() {
        return this.stage ? Number.parseFloat(getComputedStyle(this.stage).top) || 0 : 0;
      }

      shouldActivate(direction) {
        if (direction <= 0 || this.active || this.completed || this.reduced.matches || !this.stage || this.cards.length < 2) return false;
        const rect = this.getBoundingClientRect();
        const top = this.stickyTop();
        const entrySlop = Math.max(36, Math.min(80, window.innerHeight * 0.08));
        const visibleTop = Math.max(top, rect.top, 0);
        const visibleBottom = Math.min(window.innerHeight, rect.bottom);
        const visibleRatio = Math.max(0, visibleBottom - visibleTop) / Math.max(1, rect.height);
        return rect.top <= top + entrySlop && rect.bottom >= window.innerHeight * 0.72 && visibleRatio >= 0.72;
      }

      alignStage() {
        if (!this.stage) return;
        const delta = this.getBoundingClientRect().top - this.stickyTop();
        if (Math.abs(delta) < 1) return;
        const scrollingElement = document.scrollingElement || document.documentElement;
        this.aligning = true;
        scrollingElement.scrollTop = Math.max(0, scrollingElement.scrollTop + delta);
        requestAnimationFrame(() => {
          this.aligning = false;
        });
      }

      lockPage() {
        if (this.pageLock) return;
        const root = document.documentElement;
        const scrollY = window.scrollY || root.scrollTop || 0;
        this.pageLock = {
          scrollY,
          rootOverscrollBehavior: root.style.overscrollBehavior,
          rootScrollBehavior: root.style.scrollBehavior
        };
        root.style.overscrollBehavior = 'none';
        root.style.scrollBehavior = 'auto';
      }

      unlockPage() {
        if (!this.pageLock) return;
        const lock = this.pageLock;
        const root = document.documentElement;
        this.pageLock = null;
        root.style.overscrollBehavior = lock.rootOverscrollBehavior;
        root.style.scrollBehavior = lock.rootScrollBehavior;
      }

      startInteraction(source) {
        if (this.active || this.completed) return;
        this.alignStage();
        this.lockPage();
        this.active = true;
        this.classList.add('is-interaction-active');
        this.wheelTotal = 0;
        this.wheelDirection = 0;
        this.cancelExitReadiness();
        if (source === 'wheel') this.lockWheelGesture();
        if (source === 'touch') this.touchActivated = true;
        this.syncInputListeners();
      }

      releaseInteraction(completed = false) {
        this.releasing = false;
        this.active = false;
        this.classList.remove('is-interaction-active');
        this.removeGuardListener();
        this.unlockPage();
        clearTimeout(this.wheelQuietTimer);
        this.cancelExitReadiness();
        this.gestureLocked = false;
        this.wheelTotal = 0;
        this.wheelDirection = 0;
        this.resetTouch();
        if (completed) {
          this.completed = true;
          this.classList.add('is-interaction-complete');
          this.nearby = false;
          this.observer?.disconnect();
        }
        this.syncInputListeners();
      }

      finishInteraction() {
        if (this.releasing || this.completed) return;
        this.releasing = true;
        this.removeGuardListener();
        this.releaseInteraction(true);
      }

      guardActivePosition() {
        if (!this.active || this.aligning || this.guardFrame) return;
        this.guardFrame = requestAnimationFrame(() => {
          this.guardFrame = 0;
          if (!this.active || !this.stage) return;
          const rect = this.stage.getBoundingClientRect();
          const top = this.stickyTop();
          if (rect.bottom <= top + 1 || rect.top >= window.innerHeight - 1) this.releaseInteraction(false);
        });
      }

      reducedChange() {
        if (this.reduced.matches && this.active) this.releaseInteraction(false);
        this.positionTrack(this.index);
        this.syncInputListeners();
      }

      positionTrack(position) {
        if (!this.cards.length || !this.track) return;
        const bounded = Math.min(this.cards.length - 1, Math.max(0, position));
        const lowerIndex = Math.floor(bounded);
        const upperIndex = Math.ceil(bounded);
        const ratio = bounded - lowerIndex;
        const firstOffset = this.cards[0].offsetLeft;
        const lowerOffset = this.cards[lowerIndex].offsetLeft - firstOffset;
        const upperOffset = this.cards[upperIndex].offsetLeft - firstOffset;
        const offset = lowerOffset + ((upperOffset - lowerOffset) * ratio);
        this.track.style.transform = `translate3d(${-offset}px, 0, 0)`;
      }

      select(index, focus = false, alignTrack = true) {
        if (!this.cards.length) return;
        const next = Math.min(this.cards.length - 1, Math.max(0, index));
        const changed = next !== this.index;
        this.index = next;
        this.cards.forEach((card, cardIndex) => {
          const active = cardIndex === next;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-current', String(active));
          card.setAttribute('tabindex', active ? '0' : '-1');
        });
        this.mediaPanels.forEach((panel, panelIndex) => {
          const active = panelIndex === next;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
        });
        const activeCard = this.cards[next];
        if (alignTrack) this.positionTrack(next);
        if (this.currentOutput) this.currentOutput.textContent = String(next + 1).padStart(2, '0');
        if (this.previousButton) this.previousButton.disabled = next === 0;
        if (this.nextButton) this.nextButton.disabled = next === this.cards.length - 1;
        if (focus) activeCard.focus({ preventScroll: true });
        if (changed) axhPlayMedia(this);
        if (this.active && next >= this.cards.length - 1) this.armExitReadiness();
        if (this.active && next < this.cards.length - 1) this.cancelExitReadiness();
      }

      activate(index, focus = false) {
        if (this.releasing) return;
        const next = Math.min(this.cards.length - 1, Math.max(0, index));
        this.select(next, focus, true);
      }

      step(delta) {
        this.activate(this.index + delta);
      }

      keydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = Math.min(this.cards.length - 1, index + 1);
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = Math.max(0, index - 1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.cards.length - 1;
        this.activate(next, true);
      }

      pointerDown(event) {
        if (!event.isPrimary || event.pointerType === 'mouse' || this.cards.length < 2) return;
        this.pointerStart = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY
        };
        this.viewport.setPointerCapture?.(event.pointerId);
      }

      pointerUp(event) {
        if (!this.pointerStart || event.pointerId !== this.pointerStart.id) return;
        const distanceX = event.clientX - this.pointerStart.x;
        const distanceY = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        if (Math.abs(distanceX) < 42 || Math.abs(distanceX) <= Math.abs(distanceY) * 1.2) return;
        this.ignoreClickUntil = Date.now() + 400;
        this.step(distanceX < 0 ? 1 : -1);
      }

      normalizedWheelDelta(event) {
        const multiplier = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? window.innerHeight : 1;
        return event.deltaY * multiplier;
      }

      wheelThreshold() {
        return Math.max(56, Math.min(88, window.innerHeight * 0.09));
      }

      armWheelQuiet() {
        clearTimeout(this.wheelQuietTimer);
        this.wheelQuietTimer = setTimeout(() => {
          this.gestureLocked = false;
          this.wheelTotal = 0;
          this.wheelDirection = 0;
        }, 260);
      }

      lockWheelGesture() {
        this.gestureLocked = true;
        this.armWheelQuiet();
      }

      cancelExitReadiness() {
        clearTimeout(this.exitTimer);
        this.exitTimer = 0;
        this.exitReady = false;
        this.classList.remove('is-exit-pending');
      }

      armExitReadiness() {
        if (this.exitReady || this.exitTimer) return;
        this.classList.add('is-exit-pending');
        this.exitTimer = setTimeout(() => {
          this.exitTimer = 0;
          if (this.active && this.index >= this.cards.length - 1) {
            this.exitReady = true;
          }
        }, 800);
      }

      wheel(event) {
        if (event.ctrlKey || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        const delta = this.normalizedWheelDelta(event);
        if (!delta) return;
        const direction = Math.sign(delta);
        if (!this.active) {
          if (this.shouldActivate(direction)) {
            event.preventDefault();
            this.startInteraction('wheel');
          }
          return;
        }
        if (this.releasing) {
          event.preventDefault();
          return;
        }
        if (direction > 0 && this.index >= this.cards.length - 1) {
          if (this.exitReady) {
            this.finishInteraction();
            return;
          }
          event.preventDefault();
          this.armExitReadiness();
          return;
        }
        if (direction < 0) this.cancelExitReadiness();
        if (this.gestureLocked) {
          event.preventDefault();
          return;
        }
        if (this.wheelDirection && this.wheelDirection !== direction) this.wheelTotal = 0;
        this.wheelDirection = direction;
        this.wheelTotal += delta;
        if (Math.abs(this.wheelTotal) < this.wheelThreshold()) {
          event.preventDefault();
          return;
        }
        this.wheelTotal = 0;
        this.wheelDirection = 0;
        if (direction < 0) {
          event.preventDefault();
          this.finishInteraction();
          return;
        }
        event.preventDefault();
        this.select(this.index + direction);
        if (direction > 0 && this.index >= this.cards.length - 1) this.armExitReadiness();
        this.lockWheelGesture();
      }

      touchStart(event) {
        if (event.touches.length !== 1) {
          this.resetTouch();
          return;
        }
        const touch = event.touches[0];
        this.touchPoint = {
          id: touch.identifier,
          startX: touch.clientX,
          startY: touch.clientY,
          lastX: touch.clientX,
          lastY: touch.clientY
        };
        this.touchTotal = 0;
        this.touchActivated = false;
      }

      touchMove(event) {
        if (!this.touchPoint) return;
        const touch = [...event.touches].find((item) => item.identifier === this.touchPoint.id);
        if (!touch) return;
        const deltaY = this.touchPoint.lastY - touch.clientY;
        const totalX = touch.clientX - this.touchPoint.startX;
        const totalY = touch.clientY - this.touchPoint.startY;
        const horizontal = Math.abs(totalX) > Math.abs(totalY) * 1.15;
        this.touchPoint.lastX = touch.clientX;
        this.touchPoint.lastY = touch.clientY;
        if (!this.active) {
          if (!horizontal && deltaY > 0 && this.shouldActivate(1)) {
            event.preventDefault();
            this.startInteraction('touch');
            this.touchTotal = 0;
          }
          return;
        }
        if (!horizontal && deltaY > 0 && this.index >= this.cards.length - 1 && this.exitReady) {
          this.finishInteraction();
          return;
        }
        event.preventDefault();
        if (!horizontal) this.touchTotal += deltaY;
      }

      touchEnd() {
        if (!this.touchPoint) return;
        const total = this.touchTotal;
        const activated = this.touchActivated;
        this.resetTouch();
        if (!this.active || activated || Math.abs(total) < 54) return;
        const direction = Math.sign(total);
        if (direction > 0 && this.index >= this.cards.length - 1) {
          this.armExitReadiness();
          return;
        }
        if (direction < 0) {
          this.finishInteraction();
          return;
        }
        this.select(this.index + direction);
      }

      resetTouch() {
        this.touchPoint = null;
        this.touchTotal = 0;
        this.touchActivated = false;
      }

      pageKeydown(event) {
        if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target instanceof HTMLElement && event.target.matches('input, textarea, select, [contenteditable="true"]')) return;
        const forward = event.key === 'ArrowDown' || event.key === 'PageDown' || (event.key === ' ' && !event.shiftKey);
        const backward = event.key === 'ArrowUp' || event.key === 'PageUp' || (event.key === ' ' && event.shiftKey);
        if (!forward && !backward) return;
        const direction = forward ? 1 : -1;
        if (this.releasing) {
          event.preventDefault();
          return;
        }
        if (!this.active) {
          if (this.shouldActivate(direction)) {
            event.preventDefault();
            this.startInteraction('keyboard');
          }
          return;
        }
        if (direction > 0 && this.index >= this.cards.length - 1) {
          if (this.exitReady) {
            this.finishInteraction();
            return;
          }
          event.preventDefault();
          this.armExitReadiness();
          return;
        }
        if (direction < 0) {
          event.preventDefault();
          this.finishInteraction();
          return;
        }
        event.preventDefault();
        this.select(this.index + direction);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axisray-home-hotspots"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('axisray-hotspots-v2')) {
    customElements.define('axisray-hotspots-v2', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-axr-hotspot-viewport]');
        this.canvas = this.querySelector('[data-axr-hotspot-canvas]');
        this.tabs = [...this.querySelectorAll('[data-axr-hotspot-tab]')];
        this.panels = [...this.querySelectorAll('[data-axr-hotspot-panel]')];
        this.expand = this.querySelector('[data-axr-hotspot-expand]');
        this.closeButton = this.querySelector('[data-axr-hotspot-close]');
        this.sheetClose = this.querySelector('[data-axr-hotspot-sheet-close]');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.index = 0;
        this.panX = 0;
        this.panY = 0;
        this.pointer = null;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', (event) => {
            event.stopPropagation();
            this.select(index, true);
          });
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
        });
        this.expand?.addEventListener('click', () => this.openExplorer());
        this.closeButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.closeExplorer(event.detail === 0);
        });
        this.sheetClose?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.closeSheet(event.detail === 0);
        });
        this.viewport?.addEventListener('pointerdown', (event) => this.pointerDown(event));
        this.viewport?.addEventListener('pointermove', (event) => this.pointerMove(event));
        this.viewport?.addEventListener('pointerup', (event) => this.pointerUp(event));
        this.viewport?.addEventListener('pointercancel', (event) => this.pointerUp(event));
        this.onKeydown = (event) => {
          if (event.key !== 'Escape') return;
          if (this.classList.contains('is-sheet-open')) this.closeSheet(true);
          else if (this.classList.contains('is-explorer-open')) this.closeExplorer(true);
        };
        document.addEventListener('keydown', this.onKeydown);
        this.select(0, false);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        document.documentElement.classList.remove('axr-hotspots-open');
        this.unlockPage(false);
      }

      select(index, openSheet) {
        if (!this.tabs[index]) return;
        this.index = index;
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.querySelectorAll('video').forEach((video) => {
            if (active) video.play().catch(() => {});
            else video.pause();
          });
        });
        if (this.mobile.matches && openSheet && this.classList.contains('is-explorer-open')) {
          this.classList.add('is-sheet-open');
        }
      }

      onTabKeydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.select(next, true);
        this.tabs[next].focus({ preventScroll: true });
      }

      openExplorer() {
        if (!this.mobile.matches) return;
        this.lockPage();
        this.classList.add('is-explorer-open');
        document.documentElement.classList.add('axr-hotspots-open');
        this.resetPan();
        requestAnimationFrame(() => this.closeButton?.focus({ preventScroll: true }));
      }

      closeExplorer(returnFocus = false) {
        this.classList.remove('is-sheet-open');
        this.resetPan();
        this.classList.remove('is-explorer-open');
        document.documentElement.classList.remove('axr-hotspots-open');
        this.unlockPage(true);
        if (returnFocus) {
          requestAnimationFrame(() => this.expand?.focus({ preventScroll: true }));
        }
      }

      lockPage() {
        if (this.scrollLock) return;
        const pageWrapper = document.querySelector('.page-wrapper');
        const scrollingElement = document.scrollingElement || document.documentElement;
        const wrapperOverflow = pageWrapper ? getComputedStyle(pageWrapper).overflowY : '';
        const wrapperScrolls = pageWrapper
          && /^(auto|scroll|overlay)$/.test(wrapperOverflow)
          && pageWrapper.scrollHeight > pageWrapper.clientHeight;
        const scrollRoot = wrapperScrolls
          ? pageWrapper
          : scrollingElement;
        const isWindowRoot = scrollRoot === scrollingElement;
        this.scrollLock = {
          root: scrollRoot,
          isWindowRoot,
          top: isWindowRoot ? window.scrollY : scrollRoot.scrollTop,
          rootStyles: {
            overflow: scrollRoot.style.overflow,
            overflowY: scrollRoot.style.overflowY,
            overscrollBehavior: scrollRoot.style.overscrollBehavior,
            scrollBehavior: scrollRoot.style.scrollBehavior
          },
          bodyStyles: {
            position: document.body.style.position,
            top: document.body.style.top,
            right: document.body.style.right,
            left: document.body.style.left,
            width: document.body.style.width
          }
        };
        if (isWindowRoot) {
          document.body.style.position = 'fixed';
          document.body.style.top = `-${this.scrollLock.top}px`;
          document.body.style.right = '0';
          document.body.style.left = '0';
          document.body.style.width = '100%';
        } else {
          scrollRoot.style.overflow = 'hidden';
          scrollRoot.style.overflowY = 'hidden';
          scrollRoot.style.overscrollBehavior = 'none';
          scrollRoot.style.scrollBehavior = 'auto';
        }
      }

      unlockPage(restoreScroll) {
        const lock = this.scrollLock;
        if (!lock) return;
        this.scrollLock = null;
        if (lock.isWindowRoot) {
          const htmlScrollBehavior = document.documentElement.style.scrollBehavior;
          const bodyScrollBehavior = document.body.style.scrollBehavior;
          const htmlOverflowAnchor = document.documentElement.style.overflowAnchor;
          document.documentElement.style.scrollBehavior = 'auto';
          document.body.style.scrollBehavior = 'auto';
          document.documentElement.style.overflowAnchor = 'none';
          Object.assign(document.body.style, lock.bodyStyles);
          if (restoreScroll) {
            window.scrollTo(0, lock.top);
            requestAnimationFrame(() => {
              window.scrollTo(0, lock.top);
              requestAnimationFrame(() => {
                document.documentElement.style.scrollBehavior = htmlScrollBehavior;
                document.body.style.scrollBehavior = bodyScrollBehavior;
                document.documentElement.style.overflowAnchor = htmlOverflowAnchor;
              });
            });
          } else {
            document.documentElement.style.scrollBehavior = htmlScrollBehavior;
            document.body.style.scrollBehavior = bodyScrollBehavior;
            document.documentElement.style.overflowAnchor = htmlOverflowAnchor;
          }
        } else {
          Object.assign(lock.root.style, lock.rootStyles);
          if (restoreScroll) {
            lock.root.scrollTop = lock.top;
            requestAnimationFrame(() => {
              lock.root.scrollTop = lock.top;
            });
          }
        }
      }

      closeSheet(returnFocus = false) {
        this.classList.remove('is-sheet-open');
        if (returnFocus) {
          requestAnimationFrame(() => this.tabs[this.index]?.focus({ preventScroll: true }));
        }
      }

      pointerDown(event) {
        if (!this.mobile.matches || !this.classList.contains('is-explorer-open') || this.classList.contains('is-sheet-open')) return;
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, panX: this.panX, panY: this.panY };
        this.viewport.setPointerCapture?.(event.pointerId);
      }

      pointerMove(event) {
        if (!this.pointer || event.pointerId !== this.pointer.id) return;
        this.panX = this.pointer.panX + event.clientX - this.pointer.x;
        this.panY = this.pointer.panY + event.clientY - this.pointer.y;
        const maxX = window.innerWidth * 0.22;
        const maxY = window.innerHeight * 0.22;
        this.panX = Math.max(-maxX, Math.min(maxX, this.panX));
        this.panY = Math.max(-maxY, Math.min(maxY, this.panY));
        this.applyPan();
      }

      pointerUp(event) {
        if (!this.pointer || event.pointerId !== this.pointer.id) return;
        this.viewport.releasePointerCapture?.(event.pointerId);
        this.pointer = null;
      }

      applyPan() {
        this.style.setProperty('--axr-pan-x', `${this.panX}px`);
        this.style.setProperty('--axr-pan-y', `${this.panY}px`);
      }

      resetPan() {
        this.panX = 0;
        this.panY = 0;
        this.applyPan();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axisray-home-system"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('axisray-system-static')) {
    customElements.define('axisray-system-static', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-axr-system-viewport]');
        this.track = this.querySelector('[data-axr-system-track]');
        this.cards = [...this.querySelectorAll('[data-axr-system-card]')];
        this.fallback = this.querySelector('[data-axr-system-fallback]');
        this.media = [...this.querySelectorAll('[data-axr-system-media]')];
        this.current = this.querySelector('[data-axr-system-current]');
        this.previous = this.querySelector('[data-axr-system-previous]');
        this.next = this.querySelector('[data-axr-system-next]');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.cards.forEach((card, index) => card.addEventListener('click', () => this.select(index, true)));
        this.previous?.addEventListener('click', () => this.select(this.index - 1, true));
        this.next?.addEventListener('click', () => this.select(this.index + 1, true));
        this.onResize = () => this.alignTrack(false);
        this.onViewportScroll = () => {
          if (!this.mobile.matches || this.isAnimatingViewport) return;
          cancelAnimationFrame(this.viewportRaf);
          this.viewportRaf = requestAnimationFrame(() => {
            const center = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
            let nearest = 0;
            let distance = Infinity;
            this.cards.forEach((card, index) => {
              const cardCenter = card.offsetLeft + card.offsetWidth / 2;
              const nextDistance = Math.abs(cardCenter - center);
              if (nextDistance < distance) {
                distance = nextDistance;
                nearest = index;
              }
            });
            this.select(nearest, false);
          });
        };
        window.addEventListener('resize', this.onResize, { passive: true });
        this.viewport?.addEventListener('scroll', this.onViewportScroll, { passive: true });
        this.select(0, false);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        this.viewport?.removeEventListener('scroll', this.onViewportScroll);
        cancelAnimationFrame(this.viewportRaf);
        cancelAnimationFrame(this.scrollAnimationFrame);
      }

      select(index, align) {
        const nextIndex = Math.max(0, Math.min(this.cards.length - 1, index));
        this.index = nextIndex;
        this.cards.forEach((card, cardIndex) => {
          const active = cardIndex === nextIndex;
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-current', String(active));
        });
        const custom = this.media.find((panel) => Number(panel.dataset.axrSystemMedia) === nextIndex);
        [this.fallback, ...this.media].forEach((panel) => {
          if (!panel) return;
          const active = custom ? panel === custom : panel === this.fallback;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.querySelectorAll('video').forEach((video) => active ? video.play().catch(() => {}) : video.pause());
        });
        if (this.current) this.current.textContent = String(nextIndex + 1).padStart(2, '0');
        if (this.previous) this.previous.disabled = nextIndex === 0;
        if (this.next) this.next.disabled = nextIndex === this.cards.length - 1;
        if (align) this.alignTrack(true);
      }

      alignTrack(smooth) {
        const card = this.cards[this.index];
        if (!card || !this.viewport || !this.track) return;
        if (this.mobile.matches) {
          const left = card.offsetLeft - (this.viewport.clientWidth - card.offsetWidth) / 2;
          this.animateViewportTo(Math.max(0, left), smooth ? 860 : 0);
          return;
        }
        const desired = this.viewport.clientWidth / 2 - (card.offsetLeft + card.offsetWidth / 2);
        const minimum = Math.min(0, this.viewport.clientWidth - this.track.scrollWidth);
        const translated = Math.max(minimum, Math.min(0, desired));
        this.track.style.transform = `translate3d(${translated}px, 0, 0)`;
      }

      animateViewportTo(left, duration) {
        cancelAnimationFrame(this.scrollAnimationFrame);
        this.isAnimatingViewport = false;
        const start = this.viewport.scrollLeft;
        const distance = left - start;
        if (!duration || this.reduced.matches || Math.abs(distance) < 1) {
          this.viewport.scrollLeft = left;
          return;
        }
        this.isAnimatingViewport = true;
        const startedAt = performance.now();
        const tick = (now) => {
          const progress = Math.min(1, (now - startedAt) / duration);
          const eased = 1 - Math.pow(1 - progress, 4);
          this.viewport.scrollLeft = start + distance * eased;
          if (progress < 1) this.scrollAnimationFrame = requestAnimationFrame(tick);
          else {
            this.viewport.scrollLeft = left;
            this.isAnimatingViewport = false;
          }
        };
        this.scrollAnimationFrame = requestAnimationFrame(tick);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
